var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-top-nav"},[_c('b-row',[_c('b-col',{attrs:{"cols":"3"},on:{"click":function($event){return _vm.$emit('open')}}},[_c('i',{staticClass:"fas fa-bars"})]),_c('b-col',{attrs:{"cols":"6"}},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":require("../assets/host_logo_Landscape_green.png")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }